// /frontend/src/plugins/chartjs.ts

/**
 * Chart.js plugin.
 * This file registers the necessary elements from Chart.js to make them
 * available globally in the application.
 *
 * @author Alexander Funke
 * @lastChange 2025-10-08
 */

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

/**
 * Registers all necessary Chart.js components.
 * This function must be called once at application startup.
 *
 * @author Alexander Funke
 * @lastChange 2025-10-08
 */
export function registerChartJs(): void {
  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
    TimeScale,
  );
}
